/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smart_Cuddly_Mouse_ExpandInputs */

const fr_smart_cuddly_mouse_expand = /** @type {(inputs: Smart_Cuddly_Mouse_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email mis à jour avec succès`)
};

/**

* @param {Smart_Cuddly_Mouse_ExpandInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const smart_cuddly_mouse_expand = /** @type {((inputs?: Smart_Cuddly_Mouse_ExpandInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smart_Cuddly_Mouse_ExpandInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_smart_cuddly_mouse_expand(inputs)
});